export const SET_SALES_REPORT_PERIOD = 'SET_SALES_REPORT_PERIOD'
export const SET_SALES_REPORT_TOTAL_SALES = 'SET_SALES_REPORT_TOTAL_SALES'
export const SET_SALES_REPORT_IS_LOADING = 'SET_SALES_REPORT_IS_LOADING'
export const SET_SALES_REPORT_TOTAL_SUMMARY = 'SET_SALES_REPORT_TOTAL_SUMMARY'
export const SET_SALES_REPORT_TOTAL_PERIOD_FILTER = 'SET_SALES_REPORT_TOTAL_PERIOD_FILTER'
export const RE_INITIALIZE_SALES_REPORT_TOTAL_PERIOD_FILTER = 'RE_INITIALIZE_SALES_REPORT_TOTAL_PERIOD_FILTER'
export const SET_SALES_REPORT_TOTAL_PERIOD_FILTER_READY = 'SET_SALES_REPORT_TOTAL_PERIOD_FILTER_READY'
export const SET_SALES_REPORT_SORT_FILTER = 'SET_SALES_REPORT_SORT_FILTER'
export const RE_INITIALIZE_SALES_REPORT_TOTAL_SORT_FILTER = 'RE_INITIALIZE_SALES_REPORT_TOTAL_SORT_FILTER'
